export default __webpack_public_path__ + "static/media/Samantha_Dreiling_AHV_In_Moms_We_Trust.2993da57.jpg";